import React from 'react'
import {Link} from "react-router-dom"
import moment from "moment"

 var checkHours = (num) => {
  let hours = Math.floor(num / 3600);
  return hours
}

var courseTime = (e) => {
  e.preventDefault()
}

const Lastviewcard = ({lastViewCourse}) => (<div className="col-lg-4 col-sm-6 col-xs-6">
<div className="single-course">
  <div className="image-box"><img src={lastViewCourse.image} alt={lastViewCourse.title} /></div>
  <div className="text">
    {/* <div className="image"><img src={course.image} alt={course.title} /></div> */}

    <h5><Link to={`/courses/${lastViewCourse.slug}`} className="tran3s">{lastViewCourse.title}</Link></h5>
 
    <ul className="clearfix">
      <li className="float-left">
        <i className="flaticon-time"></i>
        <a href="#" className="tran3s"  onClick={(e) => courseTime(e)}>
        {checkHours(lastViewCourse.duration) ? moment.utc(lastViewCourse.duration * 1000).format('hh:mm:ss') + ' hrs' : moment.utc(lastViewCourse.duration * 1000).format('mm:ss') + ' mins'}
        </a>
      </li>
      <li className="float-right">
      <div className="name  float-right">
      {lastViewCourse.isNewCourse ? <span className="p-bg-color float-right">New</span> : null}
    </div>
      </li>
    </ul>
   
  </div>
</div>
</div>)

export default Lastviewcard